'use strict';

exports.inherit = require('inherits');
exports.clone = require('@ndhoule/clone');
exports.type = require('type-component');



//////////////////
// WEBPACK FOOTER
// ../~/segmentio-facade/lib/utils.js
// module id = 136
// module chunks = 0